const faqs = [
  {
    question: '韩国漫画网上的漫画都是免费的吗？',
    answer: '是的，韩国漫画网上的所有韩漫均为免费阅读。我们致力于为漫画爱好者提供无需付费的优质阅读体验，用户只需访问网站即可随时随地畅享海量韩漫内容。',
  },
  {
    question: '如何在不同设备上阅读韩漫？',
    answer: '韩国漫画网支持多种设备访问，包括电脑、平板和手机。网站采用响应式设计，会自动适配不同屏幕尺寸，确保您在任何设备上都能获得流畅的下拉式韩漫阅读体验。',
  },
  {
    question: '网站多久更新一次漫画内容？',
    answer: '韩国漫画网每天都会更新漫画内容，热门连载作品会随原著同步更新。您可以通过"最新更新"板块查看每日新增的漫画章节，确保不错过任何精彩内容。',
  },
  {
    question: '是否需要注册账号才能阅读？',
    answer: '不需要。韩国漫画网完全开放阅读，无需注册或登录即可访问所有漫画内容。我们坚持提供最便捷的访问方式，让您打开网站即可开始阅读。',
  },
  {
    question: '网站支持哪些类型的韩国漫画？',
    answer: '韩国漫画网涵盖丰富的韩漫类型，包括恋爱漫画、奇幻漫画、动作漫画、搞笑漫画、悬疑漫画、剧情漫画、惊悚漫画、古风漫画等，满足不同读者的阅读偏好。',
  },
];

export default function FAQSection() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-xs md:text-sm text-foreground-500 mt-1">
            关于韩国漫画网的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 text-sm font-medium text-foreground-800 list-none">
                {faq.question}
                <i className="ri-add-line text-foreground-400 group-open:hidden transition-transform"></i>
                <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}